import { render, staticRenderFns } from "./Quotazione.vue?vue&type=template&id=3c9d9916"
import script from "./Quotazione.vue?vue&type=script&lang=js"
export * from "./Quotazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports